import React from "react";

const ImageModal = ({
  imageModal,
  closeImageModal,
  navigateImage,
  setImageModal,
}) => {
  return (
    <div className="pp-image-modal-overlay" onClick={closeImageModal}>
      <div
        className="pp-image-modal-container mod-width-70p mod-height-95vh"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pp-image-modal-header">
          <span className="pp-image-modal-counter">
            {imageModal.currentIndex + 1} of {imageModal.images.length}
          </span>
          <button className="pp-image-modal-close" onClick={closeImageModal}>
            X
          </button>
        </div>

        <div className="pp-image-modal-content">
          {imageModal.images.length > 1 && (
            <button
              className="pp-image-modal-nav pp-image-modal-prev"
              onClick={() => navigateImage("prev")}
            >
              ‹
            </button>
          )}

          <img
            src={imageModal.images[imageModal.currentIndex]}
            alt={`Proof ${imageModal.currentIndex + 1}`}
            className="pp-image-modal-image"
          />

          {imageModal.images.length > 1 && (
            <button
              className="pp-image-modal-nav pp-image-modal-next"
              onClick={() => navigateImage("next")}
            >
              ›
            </button>
          )}
        </div>

        {imageModal.images.length > 1 && (
          <div className="pp-image-modal-thumbnails">
            {imageModal.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Thumbnail ${index + 1}`}
                className={`pp-image-modal-thumbnail ${
                  index === imageModal.currentIndex ? "active" : ""
                }`}
                onClick={() =>
                  setImageModal((prev) => ({
                    ...prev,
                    currentIndex: index,
                  }))
                }
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageModal;
